import type { PaymentMethod } from "@cohesive/api-client";

type CardType =
  | "Visa"
  | "Mastercard"
  | "Amex"
  | "Discover"
  | "Jcb"
  | "Diners"
  | "Unionpay"
  | "Maestro"
  | "Generic";

const CARD_BRANDS: Record<string, CardType> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  american_express: "Amex",
  discover: "Discover",
  jcb: "Jcb",
  diners: "Diners",
  diners_club: "Diners",
  unionpay: "Unionpay",
  maestro: "Maestro",
};

/** "Visa ending in 4242" / "Chase •••• 6789". Null when nothing is on file. */
export function describePaymentMethod(
  method: PaymentMethod | undefined,
): string | null {
  const card = method?.object?.card;
  if (card?.brand && card?.last4) {
    return `${CARD_BRANDS[card.brand.toLowerCase()] ?? "Card"} ending in ${card.last4}`;
  }

  const bank = method?.object?.us_bank_account;
  if (bank?.bank_name && bank?.last4) {
    return `${bank.bank_name} •••• ${bank.last4}`;
  }

  return null;
}
